import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useMutation, useQueryClient } from '@tanstack/vue-query'

/**
 * Функция удаления конфигурации
 * @param template_id
 * @param cabinet_id
 */
export const useConfiguratorTemplateDelete = (template_id: number, cabinet_id: number) => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: () =>
      http.del(`/cabinets/${cabinet_id}/admin/configurator/templates`, {
        id: template_id,
      }),
  })

  const remove = async () => {
    try {
      await mutation.mutateAsync()

      addSuccess(trs('itf.templates_removed'))

      await queryClient.invalidateQueries({
        queryKey: ['load_cabinet_admin_configurator_templates', cabinet_id],
      })
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    remove,
  }
}

/**
 * Функция сохранения шаблона
 * @param cabinet_id
 */
export const useConfiguratorTemplateSave = (cabinet_id: number) => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      if (data.id) {
        return http.put(`/cabinets/${cabinet_id}/admin/configurator/templates`, data)
      } else {
        return http.post(`/cabinets/${cabinet_id}/admin/configurator/templates`, data)
      }
    },
  })

  const save = async (data: any, valid: boolean) => {
    if (!valid) return

    try {
      await mutation.mutateAsync(data)

      addSuccess(trs('itf.templates_save'))

      await queryClient.invalidateQueries({
        queryKey: ['load_cabinet_admin_configurator_templates', cabinet_id],
      })
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    save,
  }
}

/**
 * Функция установки выбранного шаблона
 * @param cabinet_id
 */
export const useConfiguratorTemplateUse = (cabinet_id: number) => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      return http.post(`/cabinets/${cabinet_id}/admin/configurator/templates/load`, data)
    },
  })

  const use = async (data: any) => {
    try {
      await mutation.mutateAsync(data)

      addSuccess(trs('itf.templates_used'))

      await queryClient.invalidateQueries({
        queryKey: ['load_cabinet_admin_configurator', cabinet_id],
      })
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    use,
  }
}
